__turbopack_context__.v({
  "aspect-ratio-1": "gBlgPW_aspect-ratio-1",
  "brand": "gBlgPW_brand",
  "brandLogo": "gBlgPW_brandLogo",
  "breadcrumb": "gBlgPW_breadcrumb",
  "card": "gBlgPW_card",
  "cardInfo": "gBlgPW_cardInfo",
  "cardPrice": "gBlgPW_cardPrice",
  "cardSection": "gBlgPW_cardSection",
  "cardShipping": "gBlgPW_cardShipping",
  "cardStock": "gBlgPW_cardStock",
  "cartForm": "gBlgPW_cartForm",
  "contentShow": "gBlgPW_contentShow",
  "control": "gBlgPW_control",
  "dcontent": "gBlgPW_dcontent",
  "dee": "gBlgPW_dee",
  "faqs": "gBlgPW_faqs",
  "faqsHeading": "gBlgPW_faqsHeading",
  "faqsSection": "gBlgPW_faqsSection",
  "layout": "gBlgPW_layout",
  "loading": "gBlgPW_loading",
  "locs": "gBlgPW_locs",
  "main": "gBlgPW_main",
  "other": "gBlgPW_other",
  "overlay": "gBlgPW_overlay",
  "overlayShow": "gBlgPW_overlayShow",
  "price": "gBlgPW_price",
  "productImage": "gBlgPW_productImage",
  "productInfo": "gBlgPW_productInfo",
  "products": "gBlgPW_products",
  "selloc": "gBlgPW_selloc",
  "shares": "gBlgPW_shares",
  "talks": "gBlgPW_talks",
  "talkss": "gBlgPW_talkss",
  "wts": "gBlgPW_wts",
});
